$(document).ready(function () {

    $('.js-slideshow-content').initCycle({
        'slides': '> .js-slide-content',
        'pager': '.js-slideshow-thumbs',
        'pagerTemplate': '<a href="#" class="slideshow-with-content__pager"></a>',
        'pageActiveClass': 'active',
        'next': '.js-next',
        'prev': '.js-prev'
    });

});